<app-matter-form-viewer
	*ngIf="selectedForm$ | async"
	[formData]="(selectedForm$ | async)?.finalMergedData"
	[url]="(selectedForm$ | async)?.url"
	[fileName]="(selectedForm$ | async)?.name"
	class="h-full"
	[showCloseButton]="showCloseButton"
	(onClose)="_onClose()"
	(onFieldChanged)="onFieldChanged($event)"
	(finishedRendering)="_finishedRendering()"
></app-matter-form-viewer>
